import * as React from 'react';
import { cn } from '../lib/cn.js';

export function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="skeleton"
      className={cn('animate-pulse rounded-media bg-surface-sunken', className)}
      {...props}
    />
  );
}
